'use strict';

var React = require('react');

var SvgGamesConsoleMajor = function SvgGamesConsoleMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 2.774c0-.432.344-.774.77-.774h2.23v-2h-2.23a2.769 2.769 0 0 0-2.77 2.774v2.226h-3.45a5 5 0 0 0-4.977 4.516l-.557 5.737a3.416 3.416 0 0 0 6.712 1.17l.073-.291a1.5 1.5 0 0 1 1.454-1.132h3.74a1.5 1.5 0 0 1 1.454 1.132l.098.386a3.288 3.288 0 0 0 6.46-1.124l-.569-5.876a5 5 0 0 0-4.977-4.518h-3.461v-2.226Zm-5 4.226a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Zm7.5 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm3 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }));
};

exports.SvgGamesConsoleMajor = SvgGamesConsoleMajor;
